import React, { useEffect, useState } from "react";
import { Reorder, motion, useDragControls } from "framer-motion";
import Wrapper, { wrapperTypes } from "global/wrappers/Wrapper";
import UiSaveButtons from "global/components/buttons/UiSaveButtons";
import { Icon, Label } from "semantic-ui-react";
import _ from "lodash";
import { _imsTypes } from "global/wrappers/ItemMenuSquares ";

const initialIcons = [
  { key: "1", caption: "📅 Schedule" },
  { key: "2", caption: "📊 Stats" },
  { key: "3", caption: "⚙️ Settings" },
  { key: "4", caption: "🧭 Map" },
  { key: "5", caption: "📨 Messages" },
];

const _isInline = true

export default function SortableGrid({
  items,
  divFn,
  groupKey = 'gk1',
  handleSave,
  handleSelect,
  imsType,
  onSort,
  showApply,
  showReorder,
  allowReorder,
}) {

  const [currentItems, setCurrentItems] = useState(initialIcons);
  const [isSortMode, setIsSortMode] = useState();
  const [allowUpdate, setAllowUpdate] = useState()
  const [draggingKey, setDraggingKey] = useState(null);
  const [hasFirstItemLogic, setHasFirstItemLogic] = useState()

  let useFn = divFn ? true : false;

  switch (imsType) {
    case _imsTypes.sortSelect:
      useFn = false
      break;
    default:
    // nothing
  }

  useEffect(() => {
    if (items) {
      const _items = _.cloneDeep(items)
      const aaa = _.sortBy(_items, 'position')
      const _currentItems = _.map(aaa, item => item)
      const hasFirstItemLogic = _.some(_currentItems, '_isFirstItem')
      setCurrentItems(_currentItems)
      setHasFirstItemLogic(hasFirstItemLogic)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [items]);

  useEffect(() => {
    setIsSortMode(showReorder)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showReorder]);

  const handleSortUpdate = () => {
    setAllowUpdate(false)
    handleSave(currentItems)
  }

  const handleReorder_items = (itemz) => {
    setAllowUpdate(true)
    if (hasFirstItemLogic) {
      const _items = normalizeSections(itemz)
      setCurrentItems(_items)
      if (onSort) { onSort(_items) }
    } else {
      setCurrentItems(itemz)
      if (onSort) { onSort(itemz) }
    }
  }

  return (
    <div>
      <Wrapper
        wrapperType={wrapperTypes.paddedFooter}
        noMid={true}
        footer={allowReorder && showApply && !onSort && <UiSaveButtons save={{ oc: handleSortUpdate, color: 'blue', caption: 'Apply Changes', icon: 'arrow right', disabled: !allowUpdate }} />}

        content={<Reorder.Group
          key={groupKey}
          as={motion.div}
          axis="y"
          values={currentItems}
          style={{ userSelect: draggingKey ? 'none' : 'auto' }}
          onReorder={handleReorder_items}
        >
          {currentItems.map((item, index) => (
            // divFn && useFn && !showReorder ? divFn(item, item.key) :
            <SortableItem
              key={item.key || item._itemKey}
              groupKey={groupKey}
              item={item}
              index={index}
              isSortMode={isSortMode}
              showReorder={showReorder}
              draggingKey={draggingKey}
              setDraggingKey={setDraggingKey}
              imsType={imsType}
              handleSelect={handleSelect}
              divFn={divFn}
              useFn={useFn}
            >
            </SortableItem>
          ))}
        </Reorder.Group>}
      >
      </Wrapper >
    </div >
  );
}

/* 👇 NEW COMPONENT (required for hooks) */
const SortableItem = ({
  item,
  index,
  isSortMode,
  showReorder,
  draggingKey,
  setDraggingKey,
  imsType,
  handleSelect,
  groupKey,
  divFn,
  useFn,
  children,
}) => {

  const controls = useDragControls();

  const handle_click = (e) => {
    handleSelect && !showReorder && handleSelect(item, { key: groupKey })
  }

  const { position, text, value, key, caption, name, selected, display } = item ?? {}
  const { caption: caption_display } = display ?? {}

  const _index = position || index
  let _caption = text || caption_display || caption || name || value || key

  if (caption_display && _.camelCase(caption_display) !== key) {
    _caption = `${caption_display} (${_.startCase(key)})`
  }

  let useHandle;

  switch (imsType) {
    case _imsTypes.sortSelect:
      useHandle = true
      break;
    default:
      useHandle = true
    // nothing
  }

  let cn = `imsc-item ${!useHandle ? 'ndr' : 'dr'} ${item.key === draggingKey ? 'drg' : ''} ${selected ? 'sel' : ''}`

  if (item._isFirstItem) {
    cn += ' sh'
  }

  const div_item = () => {
    if (divFn && useFn) {
      return divFn(item, item.key, controls)
    }
    if (item._isFirstItem) {
      return <div className="sqr-box"><div className='imsc-item-header'>
        <Icon name={'object ungroup outline'}
          color={'blue'}
          style={{ marginRight: '1em' }}
        />
        {_.startCase(item?.propSection)}
      </div></div>
    } else {
      return <div className="sqr-box">
        <Label
          className="sqr-box-icon"
          color={'blue'}
          size='mini'
          style={useHandle ? { cursor: 'grab' } : {}}
          onPointerDownCapture={(e) => { if (useHandle) controls.start(e) }}
        >
          {_index + 1}
        </Label>
        <div>
          {_caption || '???'}
        </div>
      </div>
    }

  }

  return (
    <Reorder.Item
      as={motion.div}
      className={divFn && useFn ? null : cn}
      drag={(!item._isFirstItem && isSortMode) || useHandle}
      dragControls={useHandle ? controls : undefined} // 👈 toggle 
      dragListener={!useHandle} // 👈 toggle
      onClick={handleSelect && handle_click}
      onDragEnd={() => setDraggingKey(null)}
      onDragStart={() => setDraggingKey(item.key)}
      transition={{ type: 'spring', stiffness: 400, damping: 30 }}
      value={item}
    >
      {div_item()}
    </Reorder.Item>
  );
};

const normalizeSections = (items) => {
  const _items = _.cloneDeep(items);

  let currentSection = null;
  let position = 0

  _.forEach(_items, (item) => {
    if (item._isFirstItem) {
      currentSection = item.propSection;
      position = 0
    } else {
      item.propSection = currentSection;
      item.position = position
      position++
    }
  });

  return _items;
};

// const normalizeSections = (items) => {
//   // clone if you want to avoid mutating original
//   const _items = _.cloneDeep(items);
//   _items.forEach((item, index) => {
//     assignPropSection(_items, item, index);
//   });
//   return _items;
// };

// const assignPropSection = (items, item, index) => {
//   // search upwards for the nearest placeholder
//   for (let i = index - 1; i >= 0; i--) {
//     const candidate = items[i];
//     if (candidate._isFirstItem) {
//       item.propSection = candidate.propSection;
//       break; // stop at the first placeholder above
//     }
//   }
// };

